module.exports = __webpack_public_path__ + "img/MASTER_ENG_VP_Handbook_Web26.6be9564c.jpg";